module.exports = __webpack_public_path__ + "05_long_yellow.f4d970f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/05_long_yellow.png
// module id = P2BV
// module chunks = 0